export function createEventCatalogClient(transport) {
    return {
        /**
         * GET /internal/v1/event-catalog
         *
         * Requires scope: event-catalog:read
         */
        searchEventCatalog(q, ownerServiceId, lifecycle, limit, options) {
            return transport.request({
                method: "GET",
                path: "/internal/v1/event-catalog",
                query: { q: q, ownerServiceId: ownerServiceId, lifecycle: lifecycle, limit: limit },
                options,
            });
        },
        /**
         * POST /internal/v1/event-catalog
         *
         * Requires scope: event-catalog:write
         */
        createEventCatalogEntry(body, options) {
            return transport.request({
                method: "POST",
                path: "/internal/v1/event-catalog",
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/event-catalog/{catalogId}
         *
         * Requires scope: event-catalog:read
         */
        getEventCatalogEntry(catalogId, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/event-catalog/${encodeURIComponent(catalogId)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/event-catalog/{catalogId}/lifecycle
         *
         * Requires scope: event-catalog:write
         */
        transitionEventCatalogEntry(catalogId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/event-catalog/${encodeURIComponent(catalogId)}/lifecycle`,
                options,
            });
        },
        /**
         * List every tenant's catalogued events and every global one, as identity and lifecycle
         *
         * Requires scope: event-catalog:platform:read
         */
        listPlatformEventCatalogue(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/event-catalog",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=event-catalog.js.map